// Riferimenti fiscali indicativi (da confermare col commercialista)
export const SOGLIA_AMM = 516.46; // art. 102 TUIR: beni <= 516,46 € deducibili integralmente nell'anno

// Coefficienti di ammortamento tipici per categoria di bene (% annua)
export const COEFF_AMMORTAMENTO = [
  { cat: "Mobili e arredi", perc: 15 },
  { cat: "Macchine d'ufficio elettroniche (PC, stampanti)", perc: 20 },
  { cat: "Attrezzatura varia e minuta", perc: 15 },
  { cat: "Impianti e macchinari", perc: 15 },
  { cat: "Autovetture / automezzi", perc: 25 },
  { cat: "Telefoni cellulari", perc: 20 },
  { cat: "Fabbricati strumentali", perc: 3 },
];

// Deducibilità parziali ricorrenti (% deducibile)
export const DEDUC_PARZIALE = [
  { cat: "Autovetture (uso promiscuo)", perc: 20 },
  { cat: "Telefonia (fisso e mobile)", perc: 80 },
  { cat: "Spese di rappresentanza", perc: 75 },
  { cat: "Carburante autovetture", perc: 20 },
  { cat: "Interamente deducibile", perc: 100 },
];
